import { graphql } from '@/lib/query'
import ImageFragment from '../image'

const TeamMemberFragment = graphql(
  /* GraphQL */ `
    fragment TeamMemberFragment on TeamRecord @_unmask {
      id
      name
      description
      role
      image {
        ...ImageFragment
      }
    }
  `,
  [ImageFragment]
)

export default TeamMemberFragment
